import { render, staticRenderFns } from "./copyDesc.vue?vue&type=template&id=96fdb200&scoped=true&"
import script from "./copyDesc.vue?vue&type=script&lang=js&"
export * from "./copyDesc.vue?vue&type=script&lang=js&"
import style0 from "./copyDesc.vue?vue&type=style&index=0&id=96fdb200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fdb200",
  null
  
)

export default component.exports